import Box from '@zenbusiness/zui/Box';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';

const validIcon = (
  <SharedAsset
    alt=""
    src="/s2/vector/back-of-check-example.svg"
  />
);
const validIcon2 = (
  <SharedAsset
    alt=""
    src="/s2/vector/front-of-check-example-mini.svg"
  />
);

const CustomText = ({ children }) => (
  <Text
    color="secondary"
    size="md"
  >
    {children}
  </Text>
);

export const EducationSteps = {
  prepTheCheck: {
    title: 'Prep the check',
    content: () => (
      <>
        <CustomText>
          Sign the back and write “For Mobile Deposit at ZenBusiness” under your signature.
        </CustomText>
        <CustomText>Money in your ZenBusiness Banking account is held by Thread Bank.</CustomText>
      </>
    ),
    image: validIcon
  },
  positionInsideTheLines: {
    title: 'Position inside the lines',
    content: () => (
      <CustomText>
        Use a dark, non-reflective background. Once it’s lined up, the check will be automatically
        captured, one side at a time.
      </CustomText>
    ),
    image: validIcon2
  },
  followTheGuidelines: {
    title: 'Follow the guidelines',
    content: () => (
      <>
        <Box>
          <CustomText>Daily deposit limit: $10,000</CustomText>
          <CustomText>Monthly deposit limit: $100,000</CustomText>
        </Box>
        <CustomText>Checks cannot be:</CustomText>
        <ul>
          <li>
            <CustomText>Post-dated, or older than 6 months</CustomText>
          </li>
          <li>
            <CustomText>Payable to someone other than you</CustomText>
          </li>
          <li>
            <CustomText>Savings bonds or travelers checks</CustomText>
          </li>
          <li>
            <CustomText>In currency other than US dollars</CustomText>
          </li>
        </ul>
      </>
    )
  },
  WhenToAccessFunds: {
    title: 'When to access funds',
    content: () => (
      <CustomText>Typically, funds will be available in 5 to 7 business days.</CustomText>
    )
  }
};
